import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'

export default function TripadvisorRating({ reviews, url, writeReviewUrl }) {
  if(!reviews?.length) {
    return null
  }
  return (
    <Fragment>
      <div className='tabs-container fade-onload'>
        {reviews.map((review) => {
          return (
            <div className='tripadvisor-review-container' key={review.id}>
              <img src={review.rating_image_url} alt={review.title} />
              <div className='title'>{review.title}</div>
              <div className='main-text'>{review.text}</div>
              <div className='author-wrap clearfix'>
                <div>
                  <FormattedMessage
                    id='review_by_tripadvisor'
                    values={{ username: review.user.username }}
                    defaultMessage='Review by {username} a TripAdvisor traveler'
                  />
                </div>
                <a href={review.url} target='_blank'>
                  <FormattedMessage
                    id='read_full_review'
                    defaultMessage='Read full review'
                  />
                </a>
              </div>
            </div>
          )
        })}
        <div className='tripadvisor-review-bottom'>
          <img
            src={`${window.staticPath}travel_dist/images/trip-advisor-logo.png`}
            width='136'
          />
          <a href={url} target='_blank'>
            <FormattedMessage
              id='read_reviews'
              defaultMessage='Read all reviews'
            />
          </a>
          <a href={writeReviewUrl} target='_blank'>
            <FormattedMessage
              id='write_review'
              defaultMessage='Write a review'
            />
          </a>
          <a
            href='https://www.tripadvisor.com/pages/terms.html'
            target='_blank'
          >
            &copy; TripAdvisor {moment().format('YYYY')}
          </a>
        </div>
      </div>
    </Fragment>
  )
}
